/**
 * An object representing the state of the subscription page.
 * @constant {object} SUBSCRIPTION_PAGE_STATE
 * @property {string} CYA - Represents the account creation state.
 * @property {string} PURCHASE - Represents the purchase state.
 */
export const SUBSCRIPTION_PAGE_STATE = {
	CYA: 'ACCOUNT_CREATION',
	PURCHASE: 'PURCHASE',
};

/**
 * An object representing the offer hash overrides.
 * If an offer hash is in this object, it means we have determined that the offer hash
 * should now map to a different existing offer hash without a redirect.
 * @type {Record<string, string>} - The object mapping offer hashes to their overrides.
 */
export const OFFER_HASH_OVERRIDES = {
	'32c2abb': '123br4nd',
	'clqyu40': '73dn1wm',
};

/**
 * If an offer hash is in here it will remap to a download-app page that was built for use with walmart offers
 * @type {string[]} - the various walmart offers that map to the unique download app page
 */
// prettier-ignore
export const WALMART_OFFER_HASHES = [
	'73dn1wm',
	'clqyu40',
	'psply2j',
];
